import { Button, Input, Loader, Modal, Notification, toaster } from "rsuite";
import Label from "../Label";
import Responsive from "../Responsive";
import { useState } from "react";
import { ReferrerModel } from "../../Models/referrer.Model";
import { APi } from "../../Api";
import Swal from "sweetalert2";
import Translation from "../../translation/translation";

const ReferrerModal = ({ open, handleClose, fetchReferrers }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [model, setModel] = useState(new ReferrerModel());

  const save = () => {
    setIsLoading(true);
    APi.createAPIEndpoint(APi.ENDPOINTS.Transaction + "/CreateReferrer")
      .create({
        ...model,
      })
      .then((res) => {
        fetchReferrers();
        handleClose();
        Swal.fire({
          position: "top-end",
          icon: "success",
          title: "Element a été bien ajouté !",
          showConfirmButton: false,
          timer: 1500,
        });
        setIsLoading(false);
      })
      .catch((error) => {
        toaster.push(
          <Notification type="error" header={Translation.errorHeader} closable>
            {error?.response?.data?.title ||
              error?.response?.data?.message ||
              Translation.error}
          </Notification>,
          { placement: "topEnd" }
        );
        setIsLoading(false);
      });
  };

  return (
    <Modal
      size="sm"
      overflow={false}
      style={{
        maxHeight: "calc(100vh - 50px)",
        overflow: "auto",
        width: "40vw",
        margin: "auto",
      }}
      open={open}
      onClose={handleClose}
    >
      <Modal.Header>Ajouter un Rabatteur</Modal.Header>
      <Modal.Body>
        <div style={{ maxHeight: "calc(100vh - 240px)", overflow: "auto" }}>
          <Responsive m={12} l={12} xl={12} className="p-10">
            <Label>Nom :</Label>
            <Input
              value={model.name}
              onChange={(name) => {
                setModel((prev) => {
                  return { ...prev, name };
                });
              }}
            />
          </Responsive>
          <Responsive m={12} l={12} xl={12} className="p-10">
            <Label>Phone :</Label>
            <Input
              value={model.phone}
              onChange={(phone) => {
                setModel((prev) => {
                  return { ...prev, phone };
                });
              }}
            />
          </Responsive>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button onClick={handleClose} appearance="subtle">
          Annuler
        </Button>
        <Button onClick={save} appearance="primary">
          {isLoading ? <Loader size="sm" /> : "Enregistrer"}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ReferrerModal;
